import { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../lib/utils';
import { useTranslation } from 'react-i18next';

const TextComponent = props => {
  const { onlyText = false, type = 'default', translate = true, method = 'weglot', children, interpolation = {}, ...rest } = props;
  const { t, i18n } = useTranslation();
  const [weglotText, setWeglotText] = useState(children);
  const currentLanguage = window.Weglot.getCurrentLang();

  useEffect(() => {
    if (currentLanguage && translate && method === 'weglot' && typeof window !== 'undefined' && window.Weglot) {
      
      // Only translate if not already in English
      window.Weglot.translate(
        {
          'words': [{ "t": 1, "w": children }],
          'languageTo': currentLanguage
        },
        function(data) {
          if (data && data[0]) {
            setWeglotText(data[0]);
          }
        }
      );
    }
  }, [children, translate, method, currentLanguage]);

  const text = translate 
    ? (method === 'weglot' ? weglotText : t(children, interpolation))
    : children;
  const customProps = { ...rest, children: text };

  const options = {
    h1: ({ className }) => <h1 className={cn('font-semibold text-4xl text-center', className)} {...customProps} aria-label={text} />,
    h2: ({ className }) => <h2 className={cn('font-semibold text-3xl text-center', className)} {...customProps} aria-label={text} />,
    h3: ({ className }) => <h3 className={cn('font-semibold text-2xl text-center', className)} {...customProps} aria-label={text} />,
    h4: ({ className }) => <h4 className={cn('font-semibold text-xl text-center', className)} {...customProps} aria-label={text} />,
    h5: ({ className }) => <h5 className={cn('font-semibold text-lg text-center tracking-widest text-gray-600', className)} {...customProps} aria-label={text} />,
    h6: ({ className }) => <h6 className={cn('font-medium text-base text-center', className)} {...customProps} aria-label={text} />,
    label: ({ className }) => <span className={cn('font-bold text-base text-secondary', className)} {...customProps} aria-label={text} />,
    default: ({ className }) => <span className={cn('font-normal', className)} {...customProps} aria-label={text} />,
  };

  const Component = options[type];

  return onlyText ? text : <Component {...rest} />;
};

const Text = memo(TextComponent);

TextComponent.propTypes = {
  onlyText: PropTypes.bool,
  type: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'label', 'default']),
  translate: PropTypes.bool,
  method: PropTypes.oneOf(['weglot', 'i18next']),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  interpolation: PropTypes.object,
};

// Not Scan
export const TextNS = props => <Text {...props} />

// Not Translate
export const TextNT = props => <Text {...props} translate={false} />

export default Text;